import tinycolor from "tinycolor2";
export const primaryColor = tinycolor({ h: 255, s: 0.5, l: 0.7 });
